import { BaseUseCase } from "../../UseCaseBase";
class FamilyDetailsUseCase extends BaseUseCase {
    constructor(familyTaggingRepo) {
        super();
        this.familyTaggingRepo = familyTaggingRepo;
    }
    async fetchResult() {
        return await this.familyTaggingRepo.getFamilyDetails();
    }
}
export default FamilyDetailsUseCase;
